import { render, staticRenderFns } from "./mainAdminBarChart.vue?vue&type=template&id=190bb2e7&scoped=true"
import script from "./mainAdminBarChart.vue?vue&type=script&lang=js"
export * from "./mainAdminBarChart.vue?vue&type=script&lang=js"
import style0 from "./mainAdminBarChart.vue?vue&type=style&index=0&id=190bb2e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190bb2e7",
  null
  
)

export default component.exports